import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Kit from "./pages/Kit";
import Intake from "./pages/Intake";
import Results from "./pages/Results";
import RecipeDetail from "./pages/RecipeDetail";
import SavedRecipes from "./pages/SavedRecipes";
import Admin from "./pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kit" element={<Kit />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/results" element={<Results />} />
          <Route path="/recipe/:id" element={<RecipeDetail />} />
          <Route path="/recipe/shared" element={<RecipeDetail />} />
          <Route path="/saved" element={<SavedRecipes />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
